var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert("#pesaflowProcessingModal .modal-body[data-v-871036e2] {\n  height: 75vh;\n  overflow-y: auto;\n}\n\n#card_page .page[data-v-871036e2] {\n  position: absolute;\n  height: 100%;\n  width: 94.4%;\n  border: 1px #666;\n}")
;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sweetalert = require("sweetalert2");

var _sweetalert2 = _interopRequireDefault(_sweetalert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "Pesaflow",
  props: ["xcsrftoken", "callback_url", "request_type", "agency_url"],
  data: function data() {
    return {
      currency: null,
      logo: null,
      invoice_amount: null,
      agent_fee: 0,
      fee: 0,
      invoice_number: null,
      url: null,
      total_amount: 0,
      username: null,
      password: null,
      loading: true
    };
  },

  mounted: function mounted() {
    var _this = this;

    $("#pesaflowProcessingModal").on("hidden.bs.modal", function () {
      if (this.error == false) {
        var card = document.getElementById("card_pagev2");
        var c = $("#card_pagev2").find("iframe")[0];
        card.removeChild(c);
      }
      this.iframe = null;
      this.iframeDoc = null;
      this.loading = false;
    });
    this.invoice_number = this.$attrs["invoice_no"];
    this.invoice_amount = this.$attrs["amount_net"];
    this.currency = this.$attrs["currency"];
    this.fee = this.$attrs["fee"];
    this.agent_fee = this.$attrs["agent_fee"];
    this.url = this.$attrs["status_api_url"];
    this.logo = this.$attrs["logo"];
    this.set_total_amount();
    $("#pesaflowProcessingModal").on("shown.bs.modal", function () {
      _this.load_pesaflow_iframe();
    });
  },
  methods: {
    set_total_amount: function set_total_amount() {
      this.total_amount = parseFloat(this.invoice_amount) + parseFloat(this.fee) + parseFloat(this.agent_fee);
    },
    signin: function signin() {
      $("#pesaflowModal").modal("hide");
      $("#pesaflowProcessingModal").modal("show");
    },
    load_pesaflow_iframe: function load_pesaflow_iframe(e) {
      var _this2 = this;

      var data = {};

      var options = {
        headers: { "x-csrf-token": this.xcsrftoken }
      };
      $("#card_pagev2").show();

      this.iframe = document.createElement("iframe");

      document.getElementById("card_pagev2").appendChild(this.iframe);
      this.iframe.setAttribute("style", "width:100%;");

      this.iframe.style.height = document.getElementById("card_pagev2").scrollHeight + 25 + "px";

      Vue.axios.get(this.agency_url, data, options).then(function (response) {
        if (_this2.iframe.contentWindow) {
          _this2.iframeDoc = _this2.iframe.contentWindow;
        } else if (_this2.iframe.contentDocument.document) {
          _this2.iframeDoc = _this2.iframe.contentDocument.document;
        } else if (_this2.iframe.contentDocument) {
          _this2.iframeDoc = _this2.iframe.contentDocument;
        } else {
          _this2.error = true;
          _sweetalert2.default.fire({
            icon: "error",
            title: "Oops...",
            text: "We are unable to process this request at this time."
          });
          return;
        }

        _this2.iframeDoc.document.open();
        _this2.iframeDoc.document.write(response.data);
        _this2.iframeDoc.document.close();
      }).catch(function (error) {});
      this.loading = false;
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"pesaflowProcessingModal",staticClass:"modal fade",attrs:{"id":"pesaflowProcessingModal","aria-labelledby":"pesaflowProcessingModal","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-xl modal-dialog-centered"},[_c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('span',[_vm._v("Do not close this window until you are done !")]),_vm._v(" \n          "),(_vm.loading)?_c('div',{staticClass:"spinner-border"}):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"height":"100%"},attrs:{"id":"card_pagev2"}}),_vm._v(" "),_c('br')]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"pesaflowModal","tabindex":"-1","role":"dialog","aria-labelledby":"pesaflowModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-full",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"modal-body d-flex align-items-center"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 mx-auto"},[_c('img',{staticClass:"navbar-brand-img",attrs:{"src":_vm.logo,"alt":"..."}}),_vm._v(" "),_c('div',{staticClass:"card mt-3"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('form',[_c('label',{attrs:{"for":"email"}},[_vm._v("Username")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.username),expression:"username"}],staticClass:"form-control",attrs:{"type":"email","placeholder":"Enter your email"},domProps:{"value":(_vm.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.username=$event.target.value}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',{attrs:{"for":"email"}},[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control",attrs:{"type":"password","placeholder":"Enter your password"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"card-footer d-flex justify-content-end align-items-center"},[_c('a',{staticClass:"pull-left btn btn-link text-dark px-5",attrs:{"href":"#","data-dismiss":"modal"}},[_vm._v("Cancel")]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-outline-primary",attrs:{"href":"javascript:void(0)"},on:{"click":_vm.signin}},[_vm._v("Sign In")])])])])])])])])])])])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h3',{staticClass:"modal-title",attrs:{"id":"pesaflowProcessingModal"}},[_vm._v("Processing your request, please wait...")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('div',{staticClass:"card-footer d-flex justify-content-end align-items-center",attrs:{"id":"option_buttons"}},[_c('a',{staticClass:"btn btn-link text-dark px-5",attrs:{"href":"#","data-dismiss":"modal"}},[_vm._v("Cancel")])])])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header d-flex align-items-center"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{staticClass:"fe fe-x text-dark",attrs:{"aria-hidden":"true"}})])])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header d-flex justify-content-between"},[_c('p',{staticClass:"mb-0"},[_vm._v("Pay Using Pesaflow Agent Account")])])}]
__vue__options__._scopeId = "data-v-871036e2"
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  module.hot.dispose(__vueify_style_dispose__)
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-871036e2", __vue__options__)
  } else {
    hotAPI.reload("data-v-871036e2", __vue__options__)
  }
})()}